import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import {
  Button,
  Chip,
  Link,
  Paper,
  Typography,
} from '@material-ui/core';
import { fetch as apiFetch } from 'api';
import { convertCurrency } from 'helpers';

// Tela entre o contrato assinado e o pagamento quando a venda tem mais de
// um pagamento (pedido do founder em 23/10/2026). Cada "Pagar" abre o Asaas
// numa aba nova; esta tela continua aberta e atualiza o status quando o
// cliente volta para ela.

const descricao = (payment) => {
  if (payment.installment === 'à vista') return `${payment.method} à vista`;
  return `${payment.method}, ${payment.installment}`;
};

function Linha({ payment }) {
  let acao = null;
  if (payment.paid) {
    acao = <Chip label="Pago" color="primary" size="small" />;
  } else if (payment.url) {
    acao = (
      <Button
        variant="contained"
        color="primary"
        href={payment.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        Pagar
      </Button>
    );
  } else if (payment.kind === 'transfer') {
    acao = (
      <Typography variant="body2" color="textSecondary" style={{ maxWidth: 220, textAlign: 'right' }}>
        Dados bancários enviados por e-mail
      </Typography>
    );
  } else {
    acao = (
      <Typography variant="body2" color="textSecondary" style={{ maxWidth: 220, textAlign: 'right' }}>
        Link a caminho por e-mail
      </Typography>
    );
  }

  return (
    <Paper
      elevation={1}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '16px 20px',
        marginBottom: 12,
        flexWrap: 'wrap',
      }}
    >
      <div>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {convertCurrency(payment.value)}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {descricao(payment)}
          {payment.due_date ? ` · vence em ${moment(payment.due_date).format('DD/MM/YYYY')}` : ''}
        </Typography>
      </div>
      {acao}
    </Paper>
  );
}

function PostSignPayments({ scopeId, initialPayments, onGoToCentral }) {
  const [payments, setPayments] = useState(initialPayments || []);

  const atualizar = useCallback(() => {
    apiFetch(`salesscope/${scopeId}/customer-payments`)
      .then((res) => setPayments(res.payments || []))
      .catch(() => {});
  }, [scopeId]);

  useEffect(() => {
    window.addEventListener('focus', atualizar);
    return () => window.removeEventListener('focus', atualizar);
  }, [atualizar]);

  const pendentes = payments.filter((p) => !p.paid).length;

  return (
    <div style={{ maxWidth: 560, margin: '0 auto' }}>
      <Typography variant="body1" color="textSecondary" align="center" paragraph>
        {pendentes > 0
          ? `Falta só o pagamento. O seu contrato tem ${payments.length} pagamentos: clique em "Pagar" em cada um. O pagamento abre em outra aba, pelo Asaas, nosso parceiro de pagamentos, e esta página continua aqui.`
          : 'Tudo pago. Obrigado!'}
      </Typography>
      {payments.map((payment) => (
        <Linha key={payment.id} payment={payment} />
      ))}
      <Typography variant="body2" color="textSecondary" align="center" paragraph style={{ marginTop: 8 }}>
        Os links também foram enviados para o seu e-mail.
      </Typography>
      <Typography variant="body2" align="center">
        <Link component="button" variant="body2" onClick={onGoToCentral}>
          {pendentes > 0 ? 'Pagar depois e ir para a Central' : 'Ir para a Central'}
        </Link>
      </Typography>
    </div>
  );
}

export default PostSignPayments;
